/**
 * Wall Plate Visualizer v2
 * Features:
 * - Fixture images (plates with switches/outlets visible)
 * - Aggressive preloading on page load
 * - Loading progress indicator
 * - Optimized 800x800 images
 */

(function() {
  'use strict';

  // ========================================
  // CONFIGURATION
  // ========================================

  const CDN_BASE = 'https://cdn.shopify.com/s/files/1/0720/1131/7544/files/';

  // ========================================
  // PRODUCT DATA (with fixture images)
  // ========================================

  const PRODUCTS = {
    'Century': {
      'Toggle': {
        code: 'CE1T',
        shopifyHandle: 'century-toggle-wall-plate',
        finishes: {
          'PB': '19-W01-CE1T-PB-Oh-F.png',
          'CBB': '19-W01-CE1T-CBB-Oh-F.png',
          'SN': '19-W01-CE1T-SN-Oh-F.png',
          'SB': '19-W01-CE1T-SB-Oh-F.png'
        }
      },
      'Outlet': {
        code: 'CE1D',
        shopifyHandle: 'century-outlet-wall-plate',
        finishes: {
          'PB': '04-W01-CE1D-PB-Oh-F.png',
          'CBB': '04-W01-CE1D-CBB-Oh-F.png',
          'SN': '04-W01-CE1D-SN-Oh-F.png',
          'SB': '04-W01-CE1D-SB-Oh-F.png'
        }
      },
      'Push Button': {
        code: 'CE1S',
        shopifyHandle: 'century-push-button-wall-plate',
        finishes: {
          'PB': '06-W01-CE1S-PB-Oh-F.png',
          'CBB': '06-W01-CE1S-CBB-Oh-F.png',
          'SN': '06-W01-CE1S-SN-Oh-F.png',
          'SB': '06-W01-CE1S-SB-Oh-F.png'
        }
      },
      'Open': {
        code: 'CE1G',
        shopifyHandle: 'century-open-wall-plate',
        finishes: {
          'PB': '14-W01-CE1G-PB-Oh-F.png',
          'CBB': '14-W01-CE1G-CBB-Oh-F.png',
          'SN': '14-W01-CE1G-SN-Oh-F.png',
          'SB': '14-W01-CE1G-SB-Oh-F.png'
        }
      },
      'Blank': {
        code: 'CE1B',
        shopifyHandle: 'century-blank-wall-plate',
        // Blank plates have no fixture - use regular images
        finishes: {
          'PB': '01-W01-CE1B-PB-Oh.png',
          'CBB': '01-W01-CE1B-CBB-Oh.png',
          'SN': '01-W01-CE1B-SN-Oh.png',
          'SB': '01-W01-CE1B-SB-Oh.png'
        }
      },
      'Cable': {
        code: 'CE1CP',
        shopifyHandle: 'century-cable-wall-plate',
        finishes: {
          'PB': '02-W01-CE1CP-PB-Oh-F.png',
          'CBB': '02-W01-CE1CP-CBB-Oh-F.png',
          'SN': '02-W01-CE1CP-SN-Oh-F.png',
          'SB': '02-W01-CE1CP-SB-Oh-F.png'
        }
      }
    },
    'Futura': {
      'Toggle': {
        code: 'FU1T',
        shopifyHandle: 'futura-toggle-wall-plate',
        finishes: {
          'PB': '45-W01-FU1T-PB-Oh-F.png',
          'CBB': '45-W01-FU1T-CBB-Oh-F.png',
          'SN': '45-W01-FU1T-SN-Oh-F.png',
          'SB': '45-W01-FU1T-SB-Oh-F.png'
        }
      },
      'Outlet': {
        code: 'FU1D',
        shopifyHandle: 'futura-outlet-wall-plate',
        finishes: {
          'PB': '30-W01-FU1D-PB-Oh-F.png',
          'CBB': '30-W01-FU1D-CBB-Oh-F.png',
          'SN': '30-W01-FU1D-SN-Oh-F.png',
          'SB': '30-W01-FU1D-SB-Oh-F.png'
        }
      },
      'Push Button': {
        code: 'FU1S',
        shopifyHandle: 'futura-push-button-wall-plate',
        finishes: {
          'PB': '32-W01-FU1S-PB-Oh-F.png',
          'CBB': '32-W01-FU1S-CBB-Oh-F.png',
          'SN': '32-W01-FU1S-SN-Oh-F.png',
          'SB': '32-W01-FU1S-SB-Oh-F.png'
        }
      },
      'Open': {
        code: 'FU1G',
        shopifyHandle: 'futura-open-wall-plate',
        finishes: {
          'PB': '40-W01-FU1G-PB-Oh-F.png',
          'CBB': '40-W01-FU1G-CBB-Oh-F.png',
          'SN': '40-W01-FU1G-SN-Oh-F.png',
          'SB': '40-W01-FU1G-SB-Oh-F.png'
        }
      },
      'Blank': {
        code: 'FU1B',
        shopifyHandle: 'futura-blank-wall-plate',
        finishes: {
          'PB': '27-W01-FU1B-PB-Oh-F.png',
          'CBB': '27-W01-FU1B-CBB-Oh-F.png',
          'SN': '27-W01-FU1B-SN-Oh-F.png',
          'SB': '27-W01-FU1B-SB-Oh-F.png'
        }
      },
      'Cable': {
        code: 'FU1CP',
        shopifyHandle: 'futura-cable-wall-plate',
        finishes: {
          'PB': '28-W01-FU1CP-PB-Oh-F.png',
          'CBB': '28-W01-FU1CP-CBB-Oh-F.png',
          'SN': '28-W01-FU1CP-SN-Oh-F.png',
          'SB': '28-W01-FU1CP-SB-Oh-F.png'
        }
      }
    }
  };

  const FINISH_NAMES = {
    'PB': 'Polished Brass',
    'CBB': 'Coal Black Brass',
    'SN': 'Satin Nickel',
    'SB': 'Satin Brass'
  };

  // ========================================
  // STATE MANAGEMENT
  // ========================================

  let currentState = {
    line: 'Century',
    type: 'Toggle',
    finish: 'PB',
    wallColor: '#FAF7F2',
    imageCache: {},
    isLoading: true,
    loadProgress: 0
  };

  // ========================================
  // CANVAS & RENDERING
  // ========================================

  let canvas, ctx;

  function renderPreview() {
    if (!ctx) return;

    // Clear canvas
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Draw wall background
    ctx.fillStyle = currentState.wallColor;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Show loading state if still preloading
    if (currentState.isLoading) {
      drawLoadingState();
      return;
    }

    // Get current product image
    const product = PRODUCTS[currentState.line]?.[currentState.type];
    if (!product) {
      console.error('Product not found:', currentState.line, currentState.type);
      return;
    }

    const imagePath = product.finishes[currentState.finish];
    if (!imagePath) {
      console.error('Finish not found:', currentState.finish);
      return;
    }

    // Draw cached image (should be preloaded)
    if (currentState.imageCache[imagePath]) {
      drawImage(currentState.imageCache[imagePath]);
    } else {
      // Fallback: load on demand if not cached
      loadAndDrawImage(imagePath);
    }
  }

  function drawLoadingState() {
    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;

    // Loading text
    ctx.fillStyle = '#666666';
    ctx.font = '18px system-ui, -apple-system, sans-serif';
    ctx.textAlign = 'center';
    ctx.fillText('Loading images...', centerX, centerY - 20);

    // Progress bar background
    const barWidth = 200;
    const barHeight = 8;
    ctx.fillStyle = '#E0E0E0';
    ctx.fillRect(centerX - barWidth/2, centerY, barWidth, barHeight);

    // Progress bar fill
    ctx.fillStyle = '#B8860B';
    ctx.fillRect(centerX - barWidth/2, centerY, barWidth * currentState.loadProgress, barHeight);

    // Progress percentage
    ctx.fillStyle = '#999999';
    ctx.font = '14px system-ui, -apple-system, sans-serif';
    ctx.fillText(`${Math.round(currentState.loadProgress * 100)}%`, centerX, centerY + 30);
  }

  function loadAndDrawImage(imagePath) {
    // Check cache first
    if (currentState.imageCache[imagePath]) {
      drawImage(currentState.imageCache[imagePath]);
      return;
    }

    // Load new image
    const img = new Image();
    img.onload = function() {
      currentState.imageCache[imagePath] = img;
      drawImage(img);
    };
    img.onerror = function() {
      console.error('Failed to load image:', imagePath);
      drawErrorState();
    };

    img.src = CDN_BASE + imagePath;
  }

  function drawImage(img) {
    // First redraw wall background
    ctx.fillStyle = currentState.wallColor;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Calculate scaling to fit image within canvas while maintaining aspect ratio
    const canvasAspect = canvas.width / canvas.height;
    const imageAspect = img.width / img.height;

    let drawWidth, drawHeight;

    if (imageAspect > canvasAspect) {
      drawWidth = canvas.width * 0.85;
      drawHeight = drawWidth / imageAspect;
    } else {
      drawHeight = canvas.height * 0.85;
      drawWidth = drawHeight * imageAspect;
    }

    // Center the scaled image on canvas
    const x = (canvas.width - drawWidth) / 2;
    const y = (canvas.height - drawHeight) / 2;

    ctx.drawImage(img, x, y, drawWidth, drawHeight);
  }

  function drawErrorState() {
    ctx.fillStyle = '#CCCCCC';
    ctx.fillRect(canvas.width / 2 - 100, canvas.height / 2 - 50, 200, 100);
    ctx.fillStyle = '#666666';
    ctx.font = '16px system-ui, sans-serif';
    ctx.textAlign = 'center';
    ctx.fillText('Image not found', canvas.width / 2, canvas.height / 2);
  }

  // ========================================
  // PRELOADING (All images on page load)
  // ========================================

  function preloadAllImages() {
    return new Promise((resolve) => {
      const allImages = [];

      // Collect all image paths
      Object.values(PRODUCTS).forEach(lineProducts => {
        Object.values(lineProducts).forEach(product => {
          Object.values(product.finishes).forEach(imagePath => {
            if (!allImages.includes(imagePath)) {
              allImages.push(imagePath);
            }
          });
        });
      });

      console.log(`Preloading ${allImages.length} images...`);

      let loaded = 0;
      const total = allImages.length;

      allImages.forEach(imagePath => {
        const img = new Image();

        img.onload = () => {
          currentState.imageCache[imagePath] = img;
          loaded++;
          currentState.loadProgress = loaded / total;
          renderPreview(); // Update progress bar

          if (loaded === total) {
            console.log('All images preloaded');
            currentState.isLoading = false;
            resolve();
          }
        };

        img.onerror = () => {
          console.warn('Failed to preload:', imagePath);
          loaded++;
          currentState.loadProgress = loaded / total;
          renderPreview();

          if (loaded === total) {
            currentState.isLoading = false;
            resolve();
          }
        };

        img.src = CDN_BASE + imagePath;
      });
    });
  }

  // ========================================
  // UI UPDATES
  // ========================================

  function updateCurrentSelection() {
    const productNameEl = document.getElementById('currentProductName');
    if (!productNameEl) return;

    const finishName = FINISH_NAMES[currentState.finish] || currentState.finish;
    productNameEl.textContent = `${currentState.line} ${currentState.type} - ${finishName}`;
  }

  function updateShopButton() {
    const shopBtn = document.getElementById('shopThisProductBtn');
    if (!shopBtn) return;

    const product = PRODUCTS[currentState.line]?.[currentState.type];
    if (product?.shopifyHandle) {
      shopBtn.href = `/products/${product.shopifyHandle}`;
    }
  }

  function updateAvailableFinishes() {
    // CBB (Coal Black Brass) is only available for Futura, not Century
    const cbbSwatch = document.querySelector('.swatch__button input[value="CBB"]');
    const cbbContainer = cbbSwatch?.closest('.swatch__button');

    if (!cbbContainer) return;

    if (currentState.line === 'Century') {
      cbbContainer.style.display = 'none';

      // If CBB was selected, switch to PB
      if (currentState.finish === 'CBB') {
        currentState.finish = 'PB';
        const pbRadio = document.querySelector('.finish-swatches input[value="PB"]');
        if (pbRadio) pbRadio.checked = true;
      }
    } else {
      cbbContainer.style.display = '';
    }
  }

  // ========================================
  // EVENT HANDLERS
  // ========================================

  function handleLineChange(e) {
    // Handle both radio input change and label click
    const input = e.target.closest('input[type="radio"]');
    const label = e.target.closest('.toggle-btn');

    let line;
    if (input) {
      line = input.value;
    } else if (label) {
      line = label.dataset.line;
      // Also check the corresponding radio
      const radio = label.previousElementSibling;
      if (radio) radio.checked = true;
    } else {
      return;
    }

    if (line === currentState.line) return;

    currentState.line = line;

    // Update visual state
    document.querySelectorAll('.product-line-toggle .toggle-btn').forEach(btn => {
      btn.classList.toggle('active', btn.dataset.line === line);
    });

    updateAvailableFinishes();
    renderPreview();
    updateCurrentSelection();
    updateShopButton();
  }

  function handleTypeChange(e) {
    const button = e.target.closest('.type-btn');
    if (!button) return;

    const type = button.dataset.type;
    if (type === currentState.type) return;

    currentState.type = type;

    // Update visual state
    document.querySelectorAll('.product-type-grid .type-btn').forEach(btn => {
      const isActive = btn.dataset.type === type;
      btn.classList.toggle('active', isActive);
      btn.setAttribute('aria-pressed', isActive);
    });

    renderPreview();
    updateCurrentSelection();
    updateShopButton();
  }

  function handleFinishChange(e) {
    // Handle both radio input change and label click
    const input = e.target.closest('input[type="radio"]');
    const label = e.target.closest('label[data-finish]');

    let finish;
    let finishLabel;
    if (input) {
      finish = input.value;
      finishLabel = input.nextElementSibling;
    } else if (label) {
      finish = label.dataset.finish;
      finishLabel = label;
      // Check the corresponding radio
      const radio = document.getElementById(label.getAttribute('for'));
      if (radio) radio.checked = true;
    } else {
      return;
    }

    if (finish === currentState.finish) return;

    currentState.finish = finish;

    // Update finish name display
    const finishName = finishLabel?.dataset.name || FINISHES[finish]?.name || finish;
    const finishNameEl = document.getElementById('selectedFinishName');
    if (finishNameEl) finishNameEl.textContent = finishName;

    renderPreview();
    updateCurrentSelection();
  }

  function handleWallColorChange(e) {
    // Handle both radio input change and label click
    const input = e.target.closest('input[type="radio"]');
    const label = e.target.closest('label[data-color]');

    let color;
    if (input) {
      color = input.value;
    } else if (label) {
      color = label.dataset.color;
      // Check the corresponding radio
      const radio = document.getElementById(label.getAttribute('for'));
      if (radio) radio.checked = true;
    } else {
      return;
    }

    if (color === currentState.wallColor) return;

    currentState.wallColor = color;
    renderPreview();
  }

  // ========================================
  // INITIALIZATION
  // ========================================

  async function init() {
    canvas = document.getElementById('visualizerCanvas');
    ctx = canvas?.getContext('2d');

    if (!canvas || !ctx) {
      console.error('Canvas element not found');
      return;
    }

    // Set up event listeners - use both click and change for radio compatibility
    const lineToggle = document.querySelector('.product-line-toggle');
    if (lineToggle) {
      lineToggle.addEventListener('click', handleLineChange);
      lineToggle.addEventListener('change', handleLineChange);
    }

    const typeGrid = document.querySelector('.product-type-grid');
    if (typeGrid) {
      typeGrid.addEventListener('click', handleTypeChange);
    }

    const finishSwatches = document.querySelector('.finish-swatches');
    if (finishSwatches) {
      finishSwatches.addEventListener('click', handleFinishChange);
      finishSwatches.addEventListener('change', handleFinishChange);
    }

    const wallColorGrid = document.querySelector('.wall-color-grid');
    if (wallColorGrid) {
      wallColorGrid.addEventListener('click', handleWallColorChange);
      wallColorGrid.addEventListener('change', handleWallColorChange);
    }

    // Show initial loading state
    updateAvailableFinishes();
    renderPreview();

    // Preload all images
    await preloadAllImages();

    // Final render with loaded images
    renderPreview();
    updateCurrentSelection();
    updateShopButton();

    console.log('Wall Plate Visualizer v2 initialized');
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
